import Title from '@components/title'
import React, { Fragment, useState } from 'react'
import {
  CreateFormWrapper,
  FeeAndWinningWrapper,
  GameName,
  GameNameContainer,
  GameWrapper,
  MessageSubtitle,
  MessageTitle,
  RulesTitle,
  RulesWrapper,
  styledInput,
  StyleGameSettingsWrapper,
  StyleLabel,
  StyleMesageContainer,
} from './style'
import Row from '@components/row'
import { Form, Formik } from 'formik'
import Fields from '@components/fields'
import Column from '@components/column'
import Button from '@components/button'
import RuleLists from './rules/List'
import Svg from '@components/svg'
import { deletesvg, freefire, plus, pubg } from '@assets/icons' // make sure clock icon is available

import theme from '@utils/theme'
import { Clock } from 'lucide-react'
import { useSelector } from 'react-redux'
import { RootState } from '@store/index'
import { Match } from '@apis/index'
import { useLocation, useNavigate } from 'react-router-dom'
import { useModal } from '@context/ModalContext'
import SuccessAlert from '../success-alert-modal'
import useNavigateBack from '@hooks/useNavigateBack'

const CreateMatchRoom = () => {
  const { state } = useLocation()
  console.log(state, 'matchroom data')
  const goBack = useNavigateBack()
  const { showModal } = useModal()
  const navigate = useNavigate()
  const [initialValues, setInitialValues] = useState(() => {
    if (state) {
      return {
        gameName: state.type || '',
        team: state?.infos?.gameSettings?.matchType || '',
        date: state.date || '',
        time: '',
        slots: state.slot ? [state.slot] : [],
        firstplaceCount: state?.infos?.gameSettings?.firstPlace?.number || '',
        firstplaceAmount: state?.infos?.gameSettings?.firstPlace?.price || '',
        toprankCount: state?.infos?.gameSettings?.topRank?.number || '',
        toprankAmount: state?.infos?.gameSettings?.topRank?.price || '',
        perkillCount: state?.infos?.gameSettings?.perKill?.number || '',
        perkillAmount: state?.infos?.gameSettings?.perKill?.price || '',
        isFree: state?.infos?.isFree || '',
        matchRoomName: state.name || '',
        maxPlayers: state.teamSize || '',
        entryFee: state.entryFee || '',
        potentialWinning: state.potentialWinning || '',
      }
    }

    return {
      gameName: '',
      team: '',
      date: '',
      time: '',
      slots: [],
      firstplaceCount: '',
      firstplaceAmount: '',
      toprankCount: '',
      toprankAmount: '',
      perkillCount: '',
      perkillAmount: '',
      matchRoomName: '',
      maxPlayers: '',
      entryFee: '',
      potentialWinning: '',
      isFree: '',
    }
  })

  const handleSubmit = async (values: any) => {
    const payload = {
      name: values.matchRoomName,
      type: values.gameName,
      entryFee: values.isFree ? 0 : values.entryFee,
      potentialWinning: values.potentialWinning,
      date: values.date,
      slots: values.slots,
      teamSize: values.maxPlayers,
      infos: {
        ...(values.isFree && { isFree: values.isFree }),
        gameSettings: {
          matchType: values.team,
          firstPlace: {
            number: values.firstplaceCount,
            price: values.firstplaceAmount,
          },
          topRank: {
            number: values.toprankCount,
            price: values.toprankAmount,
          },
          perKill: {
            number: values.perkillCount,
            price: values.perkillAmount,
          },
        },
      },
    }

    try {
      if (state?.id) {
        // UPDATE
        await Match.update({
          id: state.id,
          state: 'matches',
          data: JSON.stringify(payload),
        }).then((res) => {
          console.log(res)
          showModal(<SuccessAlert data={res} />)
        })
      } else {
        // CREATE
        await Match.create({
          state: 'matches',
          data: JSON.stringify(payload),
        }).then((res) => {
          showModal(<SuccessAlert data={res[0]} />)
        })
      }
    } catch (error) {
      console.error('Submission error:', error)
    }
  }

  return (
    <Fragment>
      <Title
        textone="Game Management >"
        texttwo="Match Rooms >"
        textthree="Create Matchroom"
        textTwoClick={goBack}
        textOneClick={goBack}
      />
      <br />
      <br />
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ values, setFieldValue }) => (
          <Form>
            <Row styleRow="gap:100px">
              <CreateFormWrapper>
                <StyleMesageContainer>
                  <MessageTitle>Create your tournaments</MessageTitle>
                  <MessageSubtitle>
                    Create your own match. This match will be shown to other
                    players in this app.
                  </MessageSubtitle>
                </StyleMesageContainer>

                {/* Game Selection */}
                <GameWrapper>
                  <GameNameContainer
                    selected={values.gameName === 'FreeFire'}
                    onClick={() => setFieldValue('gameName', 'FreeFire')}
                  >
                    <Svg src={freefire} />
                    <GameName selected={values.gameName === 'FreeFire'}>
                      Free Fire
                    </GameName>
                  </GameNameContainer>

                  <GameNameContainer
                    selected={values.gameName === 'Pubg'}
                    onClick={() => setFieldValue('gameName', 'Pubg')}
                  >
                    <Svg src={pubg} />
                    <GameName selected={values.gameName === 'Pubg'}>
                      Pubg
                    </GameName>
                  </GameNameContainer>
                </GameWrapper>

                <Column>
                  <Column gap={10}>
                    <StyleLabel>Team:</StyleLabel>
                    <Fields.ChooseButton
                      name="team"
                      titleAsKey="label"
                      valueAsKey="key"
                      items={[
                        { label: 'Solo', key: 'Solo' },
                        { label: 'Duo', key: 'Duo' },
                        { label: 'Squad', key: 'Squad' },
                      ]}
                      multiple={false}
                    />
                  </Column>

                  <Column>
                    <StyleLabel>Game Time Slots</StyleLabel>
                    <Row>
                      <Fields.Input
                        type="date"
                        name="date"
                        label="Date"
                        styleInput="padding:0 5px"
                      />
                      <Fields.Input
                        type="time"
                        name="time"
                        label="Time"
                        styleInput="padding:0 5px"
                      />
                      <Svg
                        src={plus}
                        styleSvg="transform:translateY(34px)"
                        title="Add"
                        onClick={() => {
                          if (
                            values.time &&
                            !values.slots.includes(values.time)
                          ) {
                            setFieldValue('slots', [
                              ...values.slots,
                              values.time,
                            ])
                            setFieldValue('time', '')
                          }
                        }}
                      />
                    </Row>

                    <Row styleRow="max-width:450px;overflow-x:scroll">
                      {values.slots.map((slot: string, index: number) => (
                        <div
                          key={index}
                          style={{
                            fontSize: '13px',
                            display: 'flex',
                            alignItems: 'center',
                            padding: '5px 8px',
                            borderRadius: '6px',
                            gap: '8px',
                            border: `1px solid ${theme.colors.borderColor}`,
                          }}
                        >
                          <Clock width={18} />
                          <span>{slot}</span>
                          <Svg
                            src={deletesvg}
                            onClick={() =>
                              setFieldValue(
                                'slots',
                                values.slots.filter((s: string) => s !== slot),
                              )
                            }
                          />
                        </div>
                      ))}
                    </Row>
                  </Column>

                  <StyleLabel>Game Settings</StyleLabel>
                  <Fields.Switch name="isFree" label="Is Free?" />
                  <StyleGameSettingsWrapper>
                    <p>Prize Name</p>
                    <p>Total Number</p>
                    <p>Prize Amount</p>

                    <p>1st Place</p>
                    <Fields.Input name="firstplaceCount" placeholder="" />
                    <Fields.Input name="firstplaceAmount" placeholder="" />

                    <p>Top Rank</p>
                    <Fields.Input name="toprankCount" placeholder="" />
                    <Fields.Input name="toprankAmount" placeholder="" />

                    <p>Per Kill</p>
                    <Fields.Input name="perkillCount" placeholder="" />
                    <Fields.Input name="perkillAmount" placeholder="" />
                  </StyleGameSettingsWrapper>

                  <Row>
                    <Fields.Input
                      name="matchRoomName"
                      placeholder="Enter Name"
                      label="Matchroom Name"
                      type="text"
                    />
                    <Fields.Input
                      name="maxPlayers"
                      placeholder="Enter Player numbers"
                      label="Max No. of Players"
                      type="number"
                    />
                  </Row>

                  <FeeAndWinningWrapper>
                    <Row>
                      <Fields.Input
                        name="entryFee"
                        label="Entry Fee"
                        styleInput={styledInput}
                        disabled={values.isFree}
                        placeholder={`${values.isFree ? 'Entry Fee is auto set to 0 if free' : 'Set Entry Fee'}`}
                      />
                      <Fields.Input
                        name="potentialWinning"
                        label="Potential Winning"
                        styleInput={styledInput}
                        placeholder="Set Potential Win"
                      />
                    </Row>
                  </FeeAndWinningWrapper>
                </Column>
              </CreateFormWrapper>

              {/* Rules Section */}
              <Column stylecolumn="width:450px">
                <RulesWrapper>
                  <RulesTitle>Additional Rules</RulesTitle>
                  <Fields.Editor name="rules" />
                  <RuleLists gameName={values.gameName} />
                </RulesWrapper>
                <Row>
                  <Button
                    styleButton="background:red"
                    title="Cancel"
                    type="button"
                    width={100}
                    height={45}
                    onClick={() => navigate(-1)}
                  />
                  <Button
                    type="submit"
                    title={
                      state?.id ? 'Update Match Room' : 'Create Match Room'
                    }
                    width={100}
                    justify="flex-end"
                    height={45}
                  />
                </Row>
              </Column>
            </Row>
          </Form>
        )}
      </Formik>
    </Fragment>
  )
}

export default CreateMatchRoom
